import { Link, Navigate, useParams } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";
import { LOCATIONS, EXPERIENCES, CONTACT, IMG } from "../data/content";

export default function LocationDetail() {
  const { slug } = useParams();
  const loc = LOCATIONS.find((l) => l.slug === slug);
  if (!loc) return <Navigate to="/locations" replace />;

  return (
    <main>
      <PageHero
        eyebrow="Location"
        title={`Mega Celebrity Events in ${loc.name}`}
        description={loc.note}
        image={IMG.audience}
      />
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <SectionHead
            eyebrow="Experiences in This City"
            title={`What We Create in ${loc.name}`}
            description="Celebrity appearances, concerts, luxury weddings, corporate events, brand launches and complete production — planned specifically for your venue, audience and occasion."
          />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#C9A55C]/12 border border-[#C9A55C]/12">
            {EXPERIENCES.slice(0, 4).map((x) => (
              <Reveal key={x.slug}>
                <Link to={`/experiences/${x.slug}`} className="block bg-[#0D1018] p-6 h-full hover:bg-[#11141f] transition-colors duration-500">
                  <h3 className="font-display text-lg text-[#F3EEE5]">{x.title}</h3>
                  <p className="mt-2 font-accent italic text-sm text-[#A9ABB2]">{x.tagline}</p>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-12 flex flex-wrap gap-4">
              <Link to="/plan-your-event" className="btn-gold" data-testid="location-cta-btn">Check Availability in {loc.name}</Link>
              <a href={`tel:${CONTACT.phonePrimaryRaw}`} className="btn-ghost" data-testid="location-call-btn">Call {CONTACT.phonePrimary}</a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
